import Text from '@cartwhl/ui/base/Text';

const introCards = [
  {
    description:
      'Teams subscribe for API access and pay usage-based fees for motion capture, generation, and manipulation.  Higher subscription tiers unlock lower rates, more throughput, collaboration, and production support.',
  },
  {
    title: 'API Access',
    description:
      'A monthly subscription that unlocks programmatic motion generation.',
  },
  {
    title: 'Usage',
    description:
      'Motion capture, generation, and manipulation is billed per second. Higher commitments unlock lower per-second pricing.',
  },
  {
    title: 'Tiers',
    description:
      'Higher tiers unlock increased throughput, collaboration features, and production support as Cartwheel is more integrated into pipelines.',
  },
];

export default function IntroSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className="container">
        <div className="grid gap-4 md:grid-cols-2 md:gap-6">
          {introCards.map((card) => (
            <div
              key={card.title ?? card.description}
              className="bg-secondary flex flex-col gap-3 rounded-3xl p-6 lg:p-8"
            >
              {card.title && (
                <Text
                  as="h3"
                  variant="web/body/medium/md"
                  md:variant="web/body/medium/24"
                >
                  {card.title}
                </Text>
              )}
              <Text
                as="p"
                variant="web/body/medium/md"
                lg:variant="web/body/medium/24"
                className="text-tertiary leading-7!"
              >
                {card.description}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
